import { Box, CircleTag, TagColor, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Status as AuthStatus } from 'modules/payroll_integrations_datev_api/lib/authService'

interface Props {
  status: AuthStatus
}

const statusLabel = () => {
  return {
    not_authenticated: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_api.settings.login.status.not_linked.label'
    ),
    authentication_expired: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_api.settings.login.status.error.label'
    ),
    authenticated: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_api.settings.login.status.linked.label'
    ),
    not_available: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_api.settings.login.status.error.label'
    ),
  }
}

const statusDescription = () => {
  return {
    not_authenticated: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_api.settings.login.status.not_linked.description'
    ),
    authentication_expired: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_api.settings.login.status.error.description'
    ),
    authenticated: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_api.settings.login.status.linked.description'
    ),
    not_available: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_api.settings.login.status.error.description'
    ),
  }
}

const statusToTagColor = () => {
  return {
    not_authenticated: TagColor.champagne,
    authenticated: TagColor.viridian,
    authentication_expired: TagColor.radical,
    not_available: TagColor.radical,
  }
}

const Tag = ({ status }: Props) => {
  return (
    <Box width="full" flexDirection="row" gap="s16">
      <Box flexDirection="row" alignItems="center">
        <Box
          flexDirection="row"
          alignItems="center"
          style={{ marginTop: '15px', marginRight: '15px', marginBottom: '15px' }}
        >
          <CircleTag showCircle type={statusToTagColor()[status]}>
            {statusLabel()[status]}
          </CircleTag>
        </Box>

        <Text.Normal size="200">{statusDescription()[status]}</Text.Normal>
      </Box>
    </Box>
  )
}

export default Tag
